import { render, staticRenderFns } from "./ArchiveNotifications.vue?vue&type=template&id=1b43ec2b&scoped=true"
import script from "./ArchiveNotifications.vue?vue&type=script&lang=js"
export * from "./ArchiveNotifications.vue?vue&type=script&lang=js"
import style0 from "./ArchiveNotifications.vue?vue&type=style&index=0&id=1b43ec2b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b43ec2b",
  null
  
)

export default component.exports